<template>
	<div  style="width: 100%;">
		<van-overlay :show="loading" style="background-color: rgb(0 0 0 / 0%);">
			<div style="display: flex;align-items: center;justify-content: center;width: 100%;height: 100%;">
				<van-loading  color="#7d7d7d" type="spinner" />
			</div>
		</van-overlay>
		<!-- <div style="height: 30px;width: 1px;" v-if="equipment == 'pc'"></div> -->
		<div style="background-color: #fff;margin: auto;"
			:style="equipment == 'pc'?{
			 		// width:equipment == 'pc'?'1280px':'100%'
			 		...boxStyleOne,
			 	}:{
			 		width:'96%'
			 	}"
		
		>
			<div style="height: 30px;width: 1px;" v-if="equipment == 'pc'"></div>
			<div v-if="equipment == 'pc'"
			
				style="display: flex;align-items: center;margin: auto;width: fit-content;font-size: 12px;background-color: #fff;">
				<div style="width: 140px;height: 2px;background-color: #3c3d41 ;"></div>
				<div
					style="position: relative;display: flex;flex-direction: column;justify-content: center;align-items: center;">
					<div
						style="width: 30px;height: 30px;border-radius: 100%;display: flex;align-items: center;justify-content: center;color: #fff;background-color: #3c3d41;">
						1</div>
					<div style="position: absolute;width: 100px;margin-top: 60px;text-align: center;">{{$t('h.goodCart')}}</div>
				</div>
				<div style="width: 260px;height: 2px;background-color: #3c3d41;"></div>
				<div
					style="position: relative;display: flex;flex-direction: column;justify-content: center;align-items: center;">
					<div
						style="width: 28px;height: 28px;border-radius: 100%;display: flex;align-items: center;justify-content: center;color: #3c3d41;border: solid 2px #3c3d41;">
						2</div>
					<div style="position: absolute;width: 100px;margin-top: 60px;text-align: center;">{{$t('h.checkout')}}</div>
				</div>
				<div style="width: 260px;height: 2px;background-color: #3c3d41;"></div>
				<div
					style="position: relative;display: flex;flex-direction: column;justify-content: center;align-items: center;">
					<div
						style="width: 28px;height: 28px;border-radius: 100%;display: flex;align-items: center;justify-content: center;color: #3c3d41;border: solid 2px #3c3d41;">
						3</div>
					<div style="position: absolute;width: 100px;margin-top: 60px;text-align: center;">{{$t('h.pay')}}</div>
				</div>
				<div style="width: 140px;height: 2px;background-color: #3c3d41;"></div>
			</div>
			<div style="height: 30px;width: 1px;" v-if="equipment == 'pc'"></div>
			<!-- <div v-if="equipment == 'pc'" style="width: 1px;height: 30px;"></div> -->
			<div v-if="equipment == 'pc'"
				:style="equipment == 'pc'?{
				 		// width:equipment == 'pc'?'1280px':'100%'
				 		...boxStyleOne,
				 	}:{
				 		width:'96%'
				 	}"
			
				style="min-height: 600px;margin: auto;margin-top: 30px;height: 90%;overflow-y: scroll;display: flex;justify-content: center;background-color: #fff;border-radius: 10px;">
				<div style="height: 100%;width: calc(70% - 15px);background-color: #fff;border-radius: 10px;">
			
					<el-table :empty-text="' '" style="" class="custom-checkbox-table" v-if="data" ref="multipleTable" :data="data.carts"
						tooltip-effect="dark" style="width: 100%;border-radius: 10px;"
						@selection-change="handleSelectionChange" @select="selectRow" @select-all="selectAll">
						<el-table-column type="selection" width="55">
						</el-table-column>
						<el-table-column prop="name_format" :label="$t('h.goods')">
							<template slot-scope="scope">
								<div style="display: flex;align-items: center;">
									<img style="width: 80px;height: 80px;border: solid 1px #707070;"
										:src="scope.row.image" />
									<span class="two-line-ellipsis"
										style="margin-left: 20px;white-space:normal;word-wrap: break-word;max-width: 100%;hyphens: auto;word-break: break-all;">{{ scope.row.name }}</span>
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="quantity" :label="$t('h.num')">
							<template slot-scope="scope">
								<el-input-number class="custom-input-number" style="width: 100px;" size="small"
									v-model="scope.row.quantity" controls-position="right"
									@change="handleChange($event,scope.row)" :min="1"
									:max="10000000000000000000"></el-input-number>
							</template>
						</el-table-column>
						<el-table-column width="120" prop="subtotal_format" :label="$t('h.total')"  show-overflow-tooltip>
						</el-table-column>
						<el-table-column :label="$t('h.action')" width="120" show-overflow-tooltip>
							<template slot-scope="scope">
								<span class="tit" @click="delGoods(scope.row)">{{$t('h.del')}}</span>
							</template>
						</el-table-column>
					</el-table>
			
				</div>
				<div
					style="height: 100%;width: calc(26% - 15px);background-color: #fff;margin-left: 30px;border-radius: 10px;">
					<div style="margin: 10px;" v-if="data">
						<div style="font-weight: bold;">{{$t('h.priceTotal')}}</div>
						<div
							style="display: flex;justify-content: space-between;align-items: center;margin: 15px 0px;margin-top: 40px;font-size: 14px;">
							<div>{{$t('h.all')}}</div>
							<div>{{data.quantity_all}}</div>
						</div>
						<div style="width: 100%;height: 1px; background-color: #e0e2e3;"></div>
						<div
							style="display: flex;justify-content: space-between;align-items: center;margin: 15px 0px;font-size: 14px;">
							<div>{{$t('h.selectd')}}</div>
							<div>{{data.quantity}}</div>
						</div>
						<div style="width: 100%;height: 1px; background-color: #e0e2e3;"></div>
						<div
							style="display: flex;justify-content: space-between;align-items: center;margin: 15px 0px;font-size: 14px;">
							<div>{{$t('h.priceTotal')}}</div>
							<div style="font-size: 20px;font-weight: bold;">{{data.amount_format}}</div>
						</div>
						<div style="display: flex;justify-content: center;width: 100%;margin-top: 40px;">
							<el-button :style="{
								 backgroundColor:btnDisabel?'#3d3d3d':'#000'
							 }" class="btn-ok" style="background-color: #000;border: solid 1px #000;margin-top: 25px;width: 93%;margin: auto;"
								type="primary" @click="submit">{{$t('h.goCheckout')}}</el-button>
						</div>
						<div style="height: 30px;width: 1px;"></div>
					</div>
				</div>
				
			</div>
		</div>
		<div v-if="equipment == 'phone' && data" style="background-color: #fff;min-height: calc(100vh - 60px);">
			<div :key="index" v-for="(item,index) in data.carts"
				style="width: 100%;background-color: #fff;padding: 10px 0px;">
				<div style="display: flex;align-items: center;">
					<div style="margin-left: 10px;">
						<el-checkbox @change="selectRowPhone(item)" v-model="item.selected" :true-label="1"
							:false-label="0"> </el-checkbox>
					</div>
					<img style="width: 80px;height: 80px;margin-left: 10px;" :src="item.image" />
					<div style="margin-left: 10px;font-size: 14px;">
						<div class="tit-tabel">
							{{item.name}}
						</div>
						<div style="margin-top: 6px;">
							{{item.variant_labels}}
						</div>
						<div style="margin-top: 6px;color: #ff5500;">
							{{item.price_format}}
						</div>
						<div style="margin-top: 6px;display: flex;justify-content: space-between;">
							<van-stepper @change="handleChange($event,item)" v-model="item.quantity" />
							<div @click="delGoods(item)" style="margin-right: 10px;">{{$t('h.del')}}</div>
						</div>
					</div>
				</div>
			</div>
			<div style="height: 60px;"></div>
			<div
				style="width: 100%;height: 60px;background-color: #fff;border-top: solid 1px #e9eaeb;position: fixed;bottom: 0px;display: flex;align-items: center;justify-content: space-between;z-index: 100;">
				<div style="display: flex;align-items: center;margin-left: 20px;">
					<el-checkbox v-model="allSelect" @change="selectRowAllPhone" :true-label="1" :false-label="0"> </el-checkbox>
					<div style="margin-left: 10px;font-size: 12px;">
						{{$t('h.selectd')}}({{data.quantity}})
					</div>
				</div>
				<div style="display: flex;align-items: center;margin-right: 20px;">
					<div style="margin-right: 10px;font-size: 12px;font-weight: bold;">{{data.amount_format}}</div>
					<el-button :style="{
						 backgroundColor:btnDisabel?'#3d3d3d':'#000'
					 }" class="btn-ok" style="background-color: #000;border: solid 1px #000;width: fit-content;padding: 8px 12px;display: flex;align-items: center;"
						type="primary" @click="submit">{{$t('h.goCheckout')}}</el-button>
				</div>
			</div>
		</div>
		<!-- <div style="height: 30px;width: 1px;" v-if="equipment == 'pc'"></div> -->
	</div>
</template>

<script>
	import {
		getCartsData,
		getputCarts,
		getDelCarts,
		getCartsUnselect,
		getCartsSelect
	} from '../../../api/all.js'
	export default {
		props: {
			boxStyleTwo: {
				type: Object,
				default: () => {
					return {}
				}
			},
			boxStyleOne: {
				type: Object,
				default: () => {
					return {}
				}
			},
			equipment: {
				type: String,
				default: "pc"
			},
			localPageData: {
				type: Object,
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				allSelect:0,
				btnDisabel: false,
				loading: false,
				data: null
			}
		},
		methods: {

		},
		async mounted() {
			await this.getData()
		},
		methods: {
			async delGoods(item) {
				try {
					this.loading = true
					await getDelCarts({
						id: item.cart_id
					})
					await this.getData()
				} catch (e) {
					this.loading = false
				}
			},
			submit() {
				if (this.btnDisabel) {
					return
				}
				this.$router.push({
					path: '/checkout',

				})
			},
			async handleChange(e, item) {
				console.log('eee', e)
				console.log('item', item)
				this.btnDisabel = true
				const data = await getputCarts({
					sku_id: item.sku_id,
					quantity: e,
					id: item.cart_id
				})
				this.data = data.data.data
				this.$nextTick(() => {
					if(this.equipment == 'pc') {
						this.data.carts.forEach(row => {
							if (row.selected) {
								this.$refs.multipleTable.toggleRowSelection(row, true);
								this.$forceUpdate()
							}
						})
					}else{
						this.isAllPhone()
					}
					
				})
				this.btnDisabel = false
				this.$forceUpdate()
			},
			async selectAll(e) {
				try {
					let data;
					this.btnDisabel = true

					if (e.length == 0) {
						let cart_ids = []
						this.data.carts.forEach(item => {
							cart_ids.push(item.cart_id)
						})
						data = await getCartsUnselect({
							cart_ids
						})
					} else {
						let cart_ids = []
						e.forEach(item => {
							cart_ids.push(item.cart_id)
						})
						data = await getCartsSelect({
							cart_ids
						})
					}
					this.data = data.data.data
					this.$nextTick(() => {
						this.data.carts.forEach(row => {
							if (row.selected) {
								this.$refs.multipleTable.toggleRowSelection(row, true);
								this.$forceUpdate()
							}
						})
					})
					// console.log('e', e)
					this.btnDisabel = false
				} catch (e) {
					console.log('e', e)
					this.btnDisabel = false
				}

			},
			async selectRowAllPhone(e) {
				console.log('e',e)
				try {
					let data;
					let cart_ids = []
					this.data.carts.forEach(item => {
						cart_ids.push(item.cart_id)
					})
					this.btnDisabel = true
					if(e == 1) {
						data = await getCartsSelect({
							cart_ids
						})
					}else {
						data = await getCartsUnselect({
							cart_ids
						})
					}
					this.data = data.data.data
					this.btnDisabel = false
				} catch (e) {
					this.btnDisabel = false
				}
			},
			async selectRowPhone(row) {
				try {

					let data;
					this.btnDisabel = true
					if (row.selected) {
						let cart_ids = [row.cart_id]

						data = await getCartsSelect({
							cart_ids
						})

					} else {
						let cart_ids = [row.cart_id]
						data = await getCartsUnselect({
							cart_ids
						})
					}
					this.data = data.data.data
					this.isAllPhone()
					console.log('e', e)
					this.btnDisabel = false
				} catch (e) {
					console.log('e', e)
					this.btnDisabel = false
				}
			},
			async selectRow(e, row) {
				try {
					console.log('e', e)
					console.log('row', row)

					let data;
					this.btnDisabel = true
					if (row.selected) {
						let cart_ids = [row.cart_id]
						data = await getCartsUnselect({
							cart_ids
						})
					} else {
						let cart_ids = []
						e.forEach(item => {
							cart_ids.push(item.cart_id)
						})
						data = await getCartsSelect({
							cart_ids
						})
					}
					this.data = data.data.data
					this.$nextTick(() => {
						this.data.carts.forEach(row => {
							if (row.selected) {
								this.$refs.multipleTable.toggleRowSelection(row, true);
								this.$forceUpdate()
							}
						})
					})
					console.log('e', e)
					this.btnDisabel = false
				} catch (e) {
					console.log('e', e)
					this.btnDisabel = false
				}

			},
			handleSelectionChange(e) {

			},
			isAllPhone() {
				let isAll = 1
				this.data.carts.forEach(row => {
					if(row.selected == 0 && isAll == 1) {
						isAll = 0
					}
				})
				this.allSelect = isAll
			},
			async getData() {
				try {
					this.loading = true
					const data = await getCartsData()
					this.data = data.data.data
					
					//调用接口成功后执行
					console.log('data', data)
					if(this.data.amount == 0) {
						this.btnDisabel = true
					}
					this.$nextTick(() => {
						if (this.equipment == 'pc') {
							this.data.carts.forEach(row => {
								if (row.selected) {
									this.$refs.multipleTable.toggleRowSelection(row, true);
									this.$forceUpdate()
								}
							})
						}else {
							let isAll = 1
							this.data.carts.forEach(row => {
								if(row.selected == 0 && isAll == 1) {
									isAll = 0
								}
							})
							this.allSelect = isAll
						}
					})
					this.loading = false
				} catch (e) {
					this.loading = false
				}
				// await 

			}
		}
	}
</script>

<style lang="scss" scoped>
	.tit:hover {
		color: #635bff;
		cursor: pointer;
	}

	.tit-tabel {
		display: -webkit-box;
		/* 设置为WebKit内核的弹性盒子模型 */
		-webkit-box-orient: vertical;
		/* 垂直排列 */
		-webkit-line-clamp: 2;
		/* 限制显示两行 */
		overflow: hidden;
		/* 隐藏超出范围的内容 */
		text-overflow: ellipsis;
		max-width: 100%;
	}

	::v-deep .custom-checkbox-table .el-checkbox__inner {
		border-color: #999;
	}

	::v-deep .custom-checkbox-table .el-checkbox__input.is-checked .el-checkbox__inner {
		background-color: #635bff;
		border-color: #635bff;
	}

	// .two-line-ellipsis {
	// 	display: -webkit-box;
	// 	-webkit-box-orient: vertical;
	// 	-webkit-line-clamp: 2;
	// 	overflow: hidden;
	// 	text-overflow: ellipsis;
	// 	line-height: 1.5;
	// 	max-height: 3em;
	// }

	.custom-input-number {
		::v-deep .el-input__inner:focus {
			border-color: #635bff;
		}

		::v-deep .el-input--small:hover {
			border-color: #635bff;
		}

	}

	::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
		background-color: #635bff;
		border-color: #635bff;
	}

	// .custom-input-number:hover:not(.is-disabled) .el-input__inner {
	// 	border-color: #ff0000;
	// }

	// .custom-input-number.is-focus:not(.is-disabled) .el-input__inner {
	// 	border-color: #ff0000;
	// }
</style>